import React, { useMemo } from 'react';
import MiniCardContainer from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/mini-card';
import useSanityPermissionsChecker from 'helpers/hooks/useSanityPermissionsChecker';
import { LOOM_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';

interface Props {
  data: any;
  customerGroup: any;
}

const MiniCardTastic: React.FC<Props> = ({ data, customerGroup }) => {
  const { checkNestedItemPermission } = useSanityPermissionsChecker();

  if (!data) {
    return <div>Loading...</div>;
  }

  // Get cmsData from data (Sanity)
  const cmsData = data?.cmsData;
  const fields = cmsData?.dataSource?.fields;

  // Check top-level permissions first
  const hasTopLevelPermission = useMemo(() => {
    if (fields?.userRoles) {
      const fieldsOnly = { userRoles: fields.userRoles };
      return checkNestedItemPermission(fieldsOnly, customerGroup);
    }
    return true;
  }, [fields?.userRoles, customerGroup, checkNestedItemPermission]);

  if (!hasTopLevelPermission) {
    return <></>;
  }

  // Extract title info from Sanity fields
  const titleInfo = {
    mcTitle: fields?.categoryTitle || '',
    rightText: fields?.rightText || '',
    linkText: fields?.linkText || '',
    linkUrl: fields?.linkUrl || '',
    titleFontSize: fields?.titleFontSize,
  };

  // Filter categoryCards based on Sanity permissions
  const allowedCategoryCards = useMemo(() => {
    const categoryCards = fields?.categoryCards || [];

    return categoryCards.filter((card: any) => {
      return checkNestedItemPermission(card, customerGroup);
    });
  }, [fields?.categoryCards, customerGroup, checkNestedItemPermission]);

  // Map Sanity categoryCards to the format expected by MiniCardContainer
  const miniCards = useMemo(() => {
    return allowedCategoryCards.map((card: any) => ({
      text: card?.categoryTitle || card?.text,
      href: card?.categoryLink || card?.href,
      icon: card?.categoryIcon || card?.icon,
      backgroundColor: card?.backgroundColor,
      backgroundHoverColor: card?.backgroundHoverColor,
      categoryFontSize: card?.categoryFontSize,
      categoryColor: card?.categoryColor,
      backgroundImage: card?.backgroundImage,
      contentVerticalAlign: card?.contentVerticalAlign,
      contentHorizontalAlign: card?.contentHorizontalAlign,
      contentDirection: card?.contentDirection,
    }));
  }, [allowedCategoryCards]);

  const cardsData = {
    titleInfo,
    miniCards,
  };

  return <MiniCardContainer {...cardsData} titleRightClassName={LOOM_CONTENT_LOOK.miniCardTitleRightClassName} />;
};

export default MiniCardTastic;
